import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { XCircle } from "lucide-react";

// Shared "Reject with reason" dialog for the Supplier/Customer approval cycle.
export function MasterRejectDialog({ title, description, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!reason.trim()) return;
    setSaving(true);
    try { await onConfirm(reason.trim()); onClose(); } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="master-reject-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription className="text-xs">{description || "Send this record back to the planner. A reason is required so they know what to fix."}</DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder="Rejection reason (required)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="mt-1 text-sm"
          rows={3}
          data-testid="master-reject-reason"
        />
        <DialogFooter className="mt-4">
          <Button size="sm" variant="outline" className="h-8 text-xs" onClick={onClose}>Cancel</Button>
          <Button size="sm" className="h-8 text-xs bg-rose-600 hover:bg-rose-700" disabled={!reason.trim() || saving} onClick={submit} data-testid="master-reject-confirm">
            <XCircle className="h-3 w-3 mr-1" /> {saving ? "Rejecting…" : "Reject"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
